import { Project } from '@/api/rest/resources/conservation';

import { useProjectKey } from './useProjectKey';

const IMG_EXTENSIONS = ['jpg', 'png'] as const;

const getImage = ({ projectKey, name }: { projectKey: Project['id']; name: string }) => {
  const hasNameExtension = IMG_EXTENSIONS.some((ext) => name.endsWith(`.${ext}`));

  const imagePath = hasNameExtension ? name : `${name}.png`;

  return new URL(`../../projects/${projectKey}/${imagePath}`, import.meta.url).href;
};

export const useStaticImage = (name: string) => {
  const projectKey = useProjectKey();

  return getImage({ projectKey, name });
};
